import { render, staticRenderFns } from "./client-chart.vue?vue&type=template&id=67720f48"
import script from "./client-chart.vue?vue&type=script&lang=js"
export * from "./client-chart.vue?vue&type=script&lang=js"
import style0 from "./client-chart.vue?vue&type=style&index=0&id=67720f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports